import { Injectable, OnDestroy } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';
import { ProductChangeVM } from '../../models/ProductChangeVM';
import { GrowerProgramSpendComment } from '../../models/GrowerProgramSpendCommentVM';
import { SeedReservationReconcileProductChangeVM } from '../../models/SeedReservationReconcileProductChangeVM';


@Injectable()
export class SliderModelService {
  private activeSliderValue: string;

  sliderCloseRqt: Subject<boolean>;
  modelData: BehaviorSubject<any>;
  modelData2: BehaviorSubject<any>;
  modelData3: BehaviorSubject<any>;
  gmkValue: Subject<any>;
  g2gUnit: BehaviorSubject<any>;
  order2OrderUnit: BehaviorSubject<any>;
  SelectedAccountId: BehaviorSubject<number>;
  initializeProductChangeValue: BehaviorSubject<ProductChangeVM>;
  initializegpBudgetSliderValue: BehaviorSubject<any[]>;
  initializegpProgramSliderValue: BehaviorSubject<any[]>;
  initializegpCommentSliderValue: BehaviorSubject<GrowerProgramSpendComment>;
  initializeRetailerDataSliderValue: BehaviorSubject<any[]>;
  initializeReconcileVarietyDataSliderValue: BehaviorSubject<any[]>;
  retailerIndex: BehaviorSubject<any>;
  initializeCompValue: BehaviorSubject<number>;
  selectedGrowerAccId: BehaviorSubject<number>;
  addProductSlider: BehaviorSubject<boolean>;
  changeProductSlider: BehaviorSubject<boolean>;
  orderTransferSlider: BehaviorSubject<boolean>;
  diffDealerGrowerOrderTransferSlider: BehaviorSubject<boolean>;
  dealerOrderTransferSlider: BehaviorSubject<boolean>;
  growerSearchTransferSlider: BehaviorSubject<boolean>;
  retailerSearchTransferSlider: BehaviorSubject<boolean>;
  selectedPsn: BehaviorSubject<any>;
  accountInfo: BehaviorSubject<any>;
  itemAvailabilityDetailSlider: BehaviorSubject<boolean>;
  newGrowerOrderSliderClose: BehaviorSubject<boolean>;
  GrowerSearchSliderActive: BehaviorSubject<boolean>;
  toAccountNumber: BehaviorSubject<number>;
  toSellerAccountNo: BehaviorSubject<number>;
  dealerOrderInternalTransferSlider: BehaviorSubject<boolean>;
  growerProgramData: Subject<any>;
  growerProgramBudgetSlider: BehaviorSubject<boolean>;
  selectedBudgetValue: Subject<any>;
  selectedRetailerAccount: Subject<any>;
  growerProgramNameSlider: BehaviorSubject<boolean>;
  selectedProgramValue: Subject<any>;
  growerProgramCommentSlider: BehaviorSubject<boolean>;
  isNewCommenDlg: BehaviorSubject<boolean>;
  growerSearchType: BehaviorSubject<string>;
  reconcileVarietySlider: BehaviorSubject<boolean>;
  reconcileVarietySelected: Subject<any[]>;
  seedReservationReconcileAddSlider: BehaviorSubject<boolean>;
  seedReservationReconcileSliderValue: BehaviorSubject<any>;
  seedReservationReconcileAddHybridSlider: BehaviorSubject<boolean>;
  growerOrderHybridAddProductSliderValue: BehaviorSubject<any>;
  growerOrderHybridAddProductSlider: BehaviorSubject<boolean>;
  sraRequestDetailsSlider: BehaviorSubject<boolean>;
  sraRequestDetailsSliderValue: BehaviorSubject<any>;
  sraRequestDetailsCloseSliderValue: BehaviorSubject<boolean>;

  activeSlider(value: string) {
    this.activeSliderValue = value;
    switch (value) {
      case 'AddProductSlider': this.addProductSlider.next(true);
        this.modelData.next(EMPTY);
        this.sidenav.toggle();
        break;
      case 'ChangeProductSlider': this.changeProductSlider.next(true);
        this.modelData.next(EMPTY);
        this.sidenav.toggle();
        break;
      case 'orderTransferSlider': this.orderTransferSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'dealerOrderTransferSlider': this.dealerOrderTransferSlider.next(true);
        this.modelData2.next(EMPTY);
        this.sidenav.toggle();
        break;
      case 'growerSearchSlider': this.growerSearchTransferSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'ItemAvailabilityDetailSlider': this.itemAvailabilityDetailSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'DiffDealerGrowerOrderTransferSlider': this.diffDealerGrowerOrderTransferSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'dealerOrderInternalTransferSlider': this.dealerOrderInternalTransferSlider.next(true);
        this.modelData3.next(EMPTY);
        this.sidenav.toggle();
        break;
      case 'growerProgramBudgetSlider': this.growerProgramBudgetSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'retailerSearchSlider':
        this.retailerSearchTransferSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'growerProgramNameSlider': this.growerProgramNameSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'growerProgramCommentSlider':
        this.growerProgramCommentSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'reconcileVarietySliders':
        this.reconcileVarietySlider.next(true);
        this.sidenav.toggle();
        break;
      case 'seedReservationReconcileSlider':
        this.seedReservationReconcileAddSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'seedReservationReconcileHybridSlider':
        this.seedReservationReconcileAddHybridSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'growerOrderHybridAddProductSlider':
        this.growerOrderHybridAddProductSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'sraRequestDetailsSlider':
        this.sraRequestDetailsSlider.next(true);
        this.sidenav.toggle();
        break;
      case 'seedReservationReconcileSlider':
        this.seedReservationReconcileAddSlider.next(true);
        this.sidenav.toggle();
        break;
    }
  }

  public sidenav: MatSidenav;

  constructor() {
    this.addProductSlider = new BehaviorSubject(false);
    this.changeProductSlider = new BehaviorSubject(false);
    this.orderTransferSlider = new BehaviorSubject(false);
    this.diffDealerGrowerOrderTransferSlider = new BehaviorSubject(false);
    this.dealerOrderTransferSlider = new BehaviorSubject(false);
    this.growerSearchTransferSlider = new BehaviorSubject(false);
    this.retailerSearchTransferSlider = new BehaviorSubject(false);
    this.modelData = new BehaviorSubject(EMPTY);
    this.modelData2 = new BehaviorSubject(EMPTY);
    this.modelData3 = new BehaviorSubject(EMPTY);
    this.g2gUnit = new BehaviorSubject(EMPTY);
    this.order2OrderUnit = new BehaviorSubject(EMPTY);
    this.SelectedAccountId = new BehaviorSubject(0);
    this.initializeCompValue = new BehaviorSubject(0);
    this.selectedGrowerAccId = new BehaviorSubject(0);
    this.selectedPsn = new BehaviorSubject(null);
    this.initializeProductChangeValue = new BehaviorSubject(null);
    this.sliderCloseRqt = new Subject();
    this.gmkValue = new Subject();
    this.accountInfo = new BehaviorSubject(EMPTY);
    this.itemAvailabilityDetailSlider = new BehaviorSubject(false);
    this.newGrowerOrderSliderClose = new BehaviorSubject(false);
    this.GrowerSearchSliderActive = new BehaviorSubject(false);
    this.toAccountNumber = new BehaviorSubject(0);
    this.toSellerAccountNo = new BehaviorSubject(0);
    this.dealerOrderInternalTransferSlider = new BehaviorSubject(false);
    this.growerProgramData = new Subject();
    this.initializegpBudgetSliderValue = new BehaviorSubject(null);
    this.initializegpProgramSliderValue = new BehaviorSubject(null);
    this.growerProgramBudgetSlider = new BehaviorSubject(false);
    this.selectedBudgetValue = new Subject();
    this.initializeRetailerDataSliderValue = new BehaviorSubject(null);
    this.selectedRetailerAccount = new Subject();
    this.retailerIndex = new BehaviorSubject(null);
    this.growerProgramNameSlider = new BehaviorSubject(false);
    this.selectedProgramValue = new Subject();
    this.reconcileVarietySelected = new BehaviorSubject<any[]>([]);
    this.initializegpCommentSliderValue = new BehaviorSubject(null);
    this.growerProgramCommentSlider = new BehaviorSubject(false);
    this.isNewCommenDlg = new BehaviorSubject(false);
    this.growerSearchType = new BehaviorSubject('');
    this.reconcileVarietySlider = new BehaviorSubject(false);
    this.initializeReconcileVarietyDataSliderValue = new BehaviorSubject(null);
    this.sraRequestDetailsSlider = new BehaviorSubject(false);
    this.sraRequestDetailsSliderValue = new BehaviorSubject(null);
    this.sraRequestDetailsCloseSliderValue = new BehaviorSubject(false);
    this.seedReservationReconcileAddSlider = new BehaviorSubject(false);
    this.seedReservationReconcileSliderValue = new BehaviorSubject(null);
    this.growerOrderHybridAddProductSliderValue = new BehaviorSubject(null);
    this.seedReservationReconcileAddHybridSlider = new BehaviorSubject(false);
    this.growerOrderHybridAddProductSlider = new BehaviorSubject(false);
    this.sraRequestDetailsSlider = new BehaviorSubject(false);
    this.sraRequestDetailsSliderValue = new BehaviorSubject(null);
    this.sraRequestDetailsCloseSliderValue = new BehaviorSubject(false);
  }

  public SetSideNav(sidenavObj: MatSidenav) {
    this.sidenav = sidenavObj;
  }

  public close() {
    this.g2gUnit.next(EMPTY);
    this.order2OrderUnit.next(EMPTY);
    this.accountInfo.next(EMPTY);
    this.modelData.next(EMPTY);
    this.modelData2.next(EMPTY);
    this.modelData3.next(EMPTY);
    this.addProductSlider.next(false);
    this.growerProgramBudgetSlider.next(false);
    this.growerProgramNameSlider.next(false);
    this.growerProgramCommentSlider.next(false);
    this.reconcileVarietySlider.next(false);
    this.sraRequestDetailsSlider.next(false);
    this.seedReservationReconcileAddSlider.next(false);
    this.seedReservationReconcileAddHybridSlider.next(false);
    this.growerOrderHybridAddProductSlider.next(false);
    this.sraRequestDetailsSlider.next(false);
    this.sidenav.close();
  }

  public setData<T>(obj: T) {
    this.modelData.next(obj);
  }
  public setData2(obj: any) {
    this.modelData2.next(obj);
  }
  public setData3(obj: any) {
    this.modelData3.next(obj);
  }
  public selectedAccountId(value: number) {
    this.SelectedAccountId.next(value);
  }

  public setg2gTranferUnit<T>(obj: T) {
    this.g2gUnit.next(obj);
  }

  public setOrder2OrderTranferUnit<T>(obj: T) {
    this.order2OrderUnit.next(obj);
  }

  public initializeComponentVal(value: number) {
    this.initializeCompValue.next(value);
  }

  public selectedGrowerAccountId(value: number) {
    this.selectedGrowerAccId.next(value);
  }

  public selectedPerson(selected: string) {
    this.selectedPsn.next(selected);
  }

  public initializeProductChangeVal(value: ProductChangeVM) {
    this.initializeProductChangeValue.next(value);
  }

  public growerProgramBudgetSliders(value: any[]) {
    this.initializegpBudgetSliderValue.next(value);
  }

  public initializeRetailerDataValue(value: any[]) {
    this.initializeRetailerDataSliderValue.next(value);
  }

  public setRetailerSearchIndexValue(value: any) {
    this.retailerIndex.next(value);
  }

  public getRetailerSearchIndexValue() {
    return this.retailerIndex.getValue();
  }

  public growerProgramNameSliders(value: any[]) {
    this.initializegpProgramSliderValue.next(value);
  }

  public growerProgramCommentSliders(value: any) {
    this.initializegpCommentSliderValue.next(value);
  }


  public reconcileVarietySliders(value: any[]) {
    this.initializeReconcileVarietyDataSliderValue.next(value);
  }

  public setAccountInfo<T>(obj: T) {
    this.accountInfo.next(obj);
  }

  public setGMK(obj: any) {
    this.gmkValue.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.modelData.next(obj);
  }
  public getNewCommentDlgValue() {
    return this.isNewCommenDlg.getValue();
  }
  public setSeedReservationReconcileChangeVal<T>(obj: T) {
    this.seedReservationReconcileSliderValue.next(obj);
  }
  public setGrowerOrderHybridAddProductChangeVal<T>(obj: T) {
    this.growerOrderHybridAddProductSliderValue.next(obj);
  }

  public setSraRequestDetailsValue(obj: any) {
    this.sraRequestDetailsSliderValue.next(obj);
  }

  public setSraRequestDetailsCloseValue(value :boolean) {
    this.sraRequestDetailsCloseSliderValue.next(value);
  }
}
